export let googleKey = 'AIzaSyABZJIAnDHasRcdavXJDghi4msEmGPzc78';
export let demographicCriteria = [];
demographicCriteria.push({ text: 'Homme et Femme', value: 'mixte' });
demographicCriteria.push({ text: 'Homme', value: 'homme' });
demographicCriteria.push({ text: 'Femme', value: 'femme' });
export let ciCriteria = [];
ciCriteria.push({ text: 'Date', value: 3 });
ciCriteria.push({ text: 'Achat/Mode', value: 4 });
ciCriteria.push({ text: 'Automobile', value: 5 });
ciCriteria.push({ text: 'Banque', value: 6 });
ciCriteria.push({ text: 'Gratuite', value: 11 });
ciCriteria.push({ text: 'Fiscalité', value: 14 });
ciCriteria.push({ text: 'Formation', value: 15 });
ciCriteria.push({ text: 'Assurance/Santé', value: 19 });
ciCriteria.push({ text: 'Culture', value: 21 });
ciCriteria.push({ text: 'Rachat Crédit', value: 22 });
ciCriteria.push({ text: 'Bien être', value: 23 });
ciCriteria.push({ text: 'Rencontre', value: 24 });
ciCriteria.push({ text: 'Sécurité', value: 26 });
ciCriteria.push({ text: 'Renconte/Sexy', value: 27 });
ciCriteria.push({ text: 'Trading', value: 29 });
ciCriteria.push({ text: 'Voyage', value: 30 });
ciCriteria.push({ text: 'Voyance', value: 31 });
ciCriteria.push({ text: 'Achat/Hightech', value: 32 });
ciCriteria.push({ text: 'Achat/Maison', value: 36 });
ciCriteria.push({ text: 'Immobilier', value: 38 });
ciCriteria.push({ text: 'Achat/Enfant', value: 50 });
ciCriteria.push({ text: 'Assurance/Animaux', value: 55 });
ciCriteria.push({ text: 'Assurance/Auto', value: 56 });
ciCriteria.push({ text: 'Assurance/Habitation', value: 57 });
ciCriteria.push({ text: 'Pari', value: 58 });
ciCriteria.push({ text: 'Achat/Sexy', value: 59 });
ciCriteria.push({ text: 'Achat/Alimentation', value: 60 });

export let departementCODE = {};

departementCODE['Ain'.toString()] = '01';
departementCODE['Aisne'.toString()] = '02';
departementCODE['Allier'.toString()] = '03';
departementCODE['Alpes-de-Haute-Provence'.toString()] = '04';
departementCODE['Hautes-Alpes'.toString()] = '05';
departementCODE['Alpes-Maritimes'.toString()] = '06';
departementCODE['Ardèche'.toString()] = '07';
departementCODE['Ardennes'.toString()] = '08';
departementCODE['Ariège'.toString()] = '09';
departementCODE['Aube'.toString()] = '10';
departementCODE['Aude'.toString()] = '11';
departementCODE['Aveyron'.toString()] = '12';
departementCODE['Bouches-du-Rhône'.toString()] = '13';
departementCODE['Calvados'.toString()] = '14';
departementCODE['Cantal'.toString()] = '15';
departementCODE['Charente'.toString()] = '16';
departementCODE['Charente-Maritime'.toString()] = '17';
departementCODE['Cher'.toString()] = '18';
departementCODE['Corrèze'.toString()] = '19';
departementCODE['Corse-du-Sud'.toString()] = '2A';
departementCODE['Haute-Corse'.toString()] = '2B';
// let deptLabel = "Côte-d\\'Or";
// departementCODE[deptLabel] = '21';
// deptLabel = "Côtes-d\\'Armor";
// departementCODE[deptLabel] = '22';
departementCODE['Creuse'.toString()] = '23';
departementCODE['Dordogne'.toString()] = '24';
departementCODE['Doubs'.toString()] = '25';
departementCODE['Drôme'.toString()] = '26';
departementCODE['Eure'.toString()] = '27';
departementCODE['Eure-et-Loir'.toString()] = '28';
departementCODE['Finistère'.toString()] = '29';
departementCODE['Gard'.toString()] = '30';
departementCODE['Haute-Garonne'.toString()] = '31';
departementCODE['Gers'.toString()] = '32';
departementCODE['Gironde'.toString()] = '33';
departementCODE['Hérault'.toString()] = '34';
departementCODE['Ille-et-Vilaine'.toString()] = '35';
departementCODE['Indre'.toString()] = '36';
departementCODE['Indre-et-Loire'.toString()] = '37';
departementCODE['Isère'.toString()] = '38';
departementCODE['Jura'.toString()] = '39';
departementCODE['Landes'.toString()] = '40';
departementCODE['Loir-et-Cher'.toString()] = '41';
departementCODE['Loire'.toString()] = '42';
departementCODE['Haute-Loire'.toString()] = '43';
departementCODE['Loire-Atlantique'.toString()] = '44';
departementCODE['Loiret'.toString()] = '45';
departementCODE['Lot'.toString()] = '46';
departementCODE['Lot-et-Garonne'.toString()] = '47';
departementCODE['Lozère'.toString()] = '48';
departementCODE['Maine-et-Loire'.toString()] = '49';
departementCODE['Manche'.toString()] = '50';
departementCODE['Marne'.toString()] = '51';
departementCODE['Haute-Marne'.toString()] = '52';
departementCODE['Mayenne'.toString()] = '53';
departementCODE['Meurthe-et-Moselle'.toString()] = '54';
departementCODE['Meuse'.toString()] = '55';
departementCODE['Morbihan'.toString()] = '56';
departementCODE['Moselle'.toString()] = '57';
departementCODE['Nièvre'.toString()] = '58';
departementCODE['Nord'.toString()] = '59';
departementCODE['Oise'.toString()] = '60';
departementCODE['Orne'.toString()] = '61';
departementCODE['Pas-de-Calais'.toString()] = '62';
departementCODE['Puy-de-Dôme'.toString()] = '63';
departementCODE['Pyrénées-Atlantiques'.toString()] = '64';
departementCODE['Hautes-Pyrénées'.toString()] = '65';
departementCODE['Hautes-Pyrenees'.toString()] = '65';
departementCODE['Pyrénées-Orientales'.toString()] = '66';
departementCODE['Bas-Rhin'.toString()] = '67';
departementCODE['Haut-Rhin'.toString()] = '68';
departementCODE['Rhône'.toString()] = '69';
departementCODE['Haute-Saône'.toString()] = '70';
departementCODE['Saône-et-Loire'.toString()] = '71';
departementCODE['Sarthe'.toString()] = '72';
departementCODE['Savoie'.toString()] = '73';
departementCODE['Haute-Savoie'.toString()] = '74';
departementCODE['Département de Paris'.toString()] = '75';
departementCODE['Seine-Maritime'.toString()] = '76';
departementCODE['Seine-et-Marne'.toString()] = '77';
departementCODE['Yvelines'.toString()] = '78';
departementCODE['Deux-Sèvres'.toString()] = '79';
departementCODE['Somme'.toString()] = '80';
departementCODE['Tarn'.toString()] = '81';
departementCODE['Tarn-et-Garonne'.toString()] = '82';
departementCODE['Var'.toString()] = '83';
departementCODE['Vaucluse'.toString()] = '84';
departementCODE['Vendée'.toString()] = '85';
departementCODE['Vienne'.toString()] = '86';
departementCODE['Haute-Vienne'.toString()] = '87';
departementCODE['Vosges'.toString()] = '88';
departementCODE['Yonne'.toString()] = '89';
departementCODE['Territoire de Belfort'.toString()] = '90';
departementCODE['Essonne'.toString()] = '91';
departementCODE['Hauts-de-Seine'.toString()] = '92';
departementCODE['Seine-Saint-Denis'.toString()] = '93';
departementCODE['Val-de-Marne'.toString()] = '94';
// deptLabel = "Val-d\\'Oise";
// departementCODE[deptLabel] = '95';
departementCODE['Guadeloupe'.toString()] = '971';
departementCODE['Martinique'.toString()] = '972';
departementCODE['Guyane'.toString()] = '973';
departementCODE['La Réunion'.toString()] = '974';
departementCODE['Mayotte'.toString()] = '976';
